import React from 'react';

import { SearchAlienationAutoriteFourriereWarningDto } from 'lib_api/lib/api/gen';

import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { FluxDisplayName } from 'enums/flux/FluxDisplayName';

import DashboardWarningsAlienation from '../../../shared/components/DashboardWarningsAlienation';

import '../../../../css/DashboardWarnings.less';

function DashboardWarningsAutoriteFourriere(): React.ReactElement {
  function buildAdditionalColumns(): ColumnProps<SearchAlienationAutoriteFourriereWarningDto>[] {
    return [
      {
        title: 'Id autorité fourrière',
        buildCellContent: data => data.autoriteFourriereId,
      },
      {
        title: 'Id corrélation autorité fourrière',
        buildCellContent: data => data.autoriteFourriereIdCorrelation,
      },
    ];
  }
  return (
    <DashboardWarningsAlienation
      getControllerFunctionFetchFlux={controller =>
        controller.searchSpecificFluxAutoriteFouriereUsingGET.bind(controller)
      }
      getControllerFunctionFetchWarnings={controller =>
        controller.searchWarningsFluxAutoriteFourriereUsingGET.bind(controller)
      }
      buildSpecificTableColumns={buildAdditionalColumns}
      tableTitle={FluxDisplayName.ALIENATION_AUTORITE_FOURRIERE}
    />
  );
}

export default DashboardWarningsAutoriteFourriere;
